import { t } from "ttag";

interface IAuditAction {
  [action: string]: string;
}

const AuditActions: IAuditAction = {
  createCustomer: t`Created Customer`,
  updateCustomer: t`Updated Customer`,
  deleteCustomer: t`Deleted Customer`,
  createSite: t`Created Site`,
  updateSite: t`Updated Site`,
  deleteSite: t`Deleted Site`,
  createDevice: t`Created Device`,
  updateDevice: t`Updated Device`,
  deleteDevice: t`Deleted Device`,
  createGroup: t`Created Group`,
  updateGroup: t`Updated Group`,
  deleteGroup: t`Deleted Group`,
  addGroupUnit: t`Added Group Unit`,
  removeGroupUnit: t`Removed Group Unit`,
  setGroupFanMode: t`Set Group Fan Mode`,
  setGroupSwingMode: t`Set Group Swing Mode`,
  createAlertGroup: t`Created Alert Group`,
  updateAlertGroup: t`Updated Alert Group`,
  deleteAlertGroup: t`Deleted Alert Group`,
  createSystem: t`Created System`,
  updateSystem: t`Updated System`,
  updatePowerMeter: t`Updated Power Meter`,
  assignPowerMeterToSystem: t`Assign Power Meter To System`,
  unassignPowerMeterToSystem: t`Unassign Power Meter From System`,
  deleteSystem: t`Deleted System`,
  addSystemUnit: t`Added System Unit`,
  removeSystemUnit: t`Removed System Unit`,
  setSystemSetpoint: t`Set System Setpoint`,
  setSystemOperationStatus: t`Set System Operation Status`,
  setSystemOperationMode: t`Set System Operation Mode`,
  setSystemSetPoint: t`Set System Setpoint`,
  setSystemFanMode: t`Set System Fan Mode`,
  setSystemSwingMode: t`Set System Swing Mode`,
  updateUnit: t`Updated Unit`,
  deleteUnit: t`Deleted Unit`,
  clearUnitFilter: t`Clear unit filter`,
  deleteUser: t`Deleted User`,
  setUnitSetpoint: t`Set Unit Setpoint`,
  setUnitOperationStatus: t`Set Unit Operation Status`,
  setUnitOperationMode: t`Set Unit Operation Mode`,
  setUnitFanMode: t`Set Unit Fan Mode`,
  setUnitSwingMode: t`Set Unit Swing Mode`,
  setUnitTempCurve: t`Set Unit Temp Curve`,
  setUnitLock: t`Set Unit Lock`,
  autoIndoorUnitMapping: t`Automatic indoor unit mapping`,
  createSchedule: t`Created Schedule`,
  updateSchedule: t`Updated Schedule`,
  deleteSchedule: t`Deleted Schedule`,
  createInvite: t`Created Invite`,
  acceptInvite: t`Accepted Invite`,
  deleteInvite: t`Deleted Invite`,
  updateUser: t`Updated User`,
  updateUserPassword: t`Updated User Password`,
  createTrap: t`Created Anomaly Trigger`,
  updateTrap: t`Updated Anomaly Trigger`,
  deleteTrap: t`Deleted Anomaly Trigger`,
  updateEvent: t`Updated Alert`,
  deleteEvent: t`Deleted Alert`,
  login: t`Login`,
  deleteNote: t`Deleted Note`,
  createNote: t`Created Note`,
  uploadFile: t`Upload file`,
  updateFile: t`Updated File`,
  deleteFile: t`Deleted File`,
  createSubscription: t`Created Subscription`,
  updateSubscription: t`Updated Subscription`,
  deleteSubscription: t`Deleted Subscription`,
  createContact: t`Create Contact`,
  updateContact: t`Updated Contact`,
  deleteContact: t`Delete Contact`,
  addAlertGroupContact: t`Assign Contact to Alert Group`,
  updateAlertGroupContact: t`Update Alert Group Contact`,
  updateAlertGroupContacts: t`Update Multiple Alert Group Contacts`,
  removeAlertGroupContact: t`Remove Contact from Alert Group`,
  unitResetWorkingHours: t`Reset unit working hours`,
  unitLimitsScheduleOn: t`unit app restrictions schedule start`,
  unitLimitsScheduleOff: t`unit app restrictions schedule end`,
  eWrcLimitsScheduleOn: t`unit WRC restrictions schedule start`,
  eWrcLimitsScheduleOff: t`unit WRC restrictions schedule end`,
  setSensorValue: t`Set sensor value`,
  setGroupSetpoint: t`Set Group Setpoint`,
  setGroupOperationStatus: t`Set Group Operation Status`,
  setGroupOperationMode: t`Set Group Operation Mode`,
  verifySchedule: t`Verified Schedule`,
  deleteSensor: t`Deleted Sensor`,
  updateSensor: t`Updated Sensor`,
  resetUnit: t`Reset Unit`,
  updateUnitSubType: t`Updated Unit SubType`,
  setWaterHeaterSetpoint: t`Set water Heater Setpoint`,
  setWaterHeaterOperationStatus: t`Set Heater Operation Status`,
  setWaterHeaterOperationMode: t`Set Heater Operation Mode`,
  setUnitServiceParam: t`Set Service Parameter`,
  setSiteSetting: t`Set Site Setting`,
  refreshDevice: t`Refresh Device`,
  migrateUnitNames: t`Migrate Unit Names`,
  migrateZones: t`Migrate Zones`,
  deleteRuleSchedule: t`Deleted Rule Schedule`,
  deleteWrcLockSchedule: t`Deleted Wrc Lock Schedule`,
  deleteUnitLimitSchedule: t`Delete Unit Limit Schedule`,
  createUnitLimitSchedule: t`Create Unit Limit Schedule`,
  createWrcLockSchedule: t`Create Wrc Lock Schedule`,
  updateRuleSchedule: t`Updated Rule Schedule`,
  updateWrcLockSchedule: t`Updated Wrc Lock Schedule`,
  updateUnitLimitSchedule: t`Updated Unit Limit Schedule`,
  createAutomationLogic: t`Created Automation Logic`,
  updateAutomationLogic: t`Updated Automation Logic`,
  deleteAutomationLogic: t`Deleted Automation Logic`,
  createMigrateSite: t`Created Migrate Site`,
  setAcknowledgedEvent: t`Acknowledge Alert`,
  setUnAcknowledgedEvent: t`Cancel Acknowledge Alert`,
  closeEvent: t`Close Alert`,
  createZone: t`Created Zone`,
  updateZone: t`Updated Zone`,
  deleteZone: t`Deleted Zone`,
  reportingSiteSystemsDiversity: t`Reporting Site Systems Diversity`,
  createFloorPlan: t`Created Floor Plan`,
  updateFloorPlan: t`Updated Floor Plan`,
  deleteFloorPlan: t`Deleted Floor Plan`,
  createProcedure: t`Create procedure`,
  updateProcedure: t`Update procedure`,
  deleteProcedure: t`Delete procedure`,
  runProcedure: t`Run procedure`,
  stopProcedure: t`Stop procedure`,
  undefined: t`Delete procedure report`,
  createSystemsChangeover: t`Created Systems Changeover`,
  deleteSystemsChangeover: t`Deleted Systems Changeover`,
  updateSystemsChangeover: t`Updated Systems Changeover`,
  createUnitsChangeover: t`Created Units Changeover`,
  deleteUnitsChangeover: t`Deleted Units Changeover`,
  updateUnitsChangeover: t`Updated Units Changeover`,
  eWrcTStatLocks: t`Set unit EWrc restrictions`,
  disableEWrcTStatLocks: t`Disable EWrc TStat Locks`,
  enableEWrcTStatLocks: t`Enable EWrc Tstat Locks`,
  createReportSchedule: t`Create Report Schedule`,
  deleteReportSchedule: t`Delete Report Schedule`,
  updateReportSchedule: t`Updated Report Schedule`,
  setAutoAcknowledgedEvent: t`Auto Acknowledge Alert`,
  cancelAutoAcknowledgedEvent: t`Cancel Auto Acknowledge Alert`,
  createTimer: t`Created Timer`,
  updateTimer: t`Updated Timer`,
  deleteTimer: t`Deleted Timer`,
  createDualSetpointRule: t`Created Dual Setpoint Rule`,
  updateDualSetpointRule: t`Updated Dual Setpoint Rule`,
  deleteDualSetpointRule: t`Deleted Dual Setpoint Rule`,
  replaceDevice: t`Replace Device`,
  createSmartRule: t`Created Smart Rule`,
  updateSmartRule: t`Updated Smart Rule`,
  deleteSmartRule: t`Deleted Smart Rule`,
  addPoliciesToInvite: t`Added Policies To Invite`,
  deletePoliciesFromInvite: t`Deleted Policies From Invite`,
  deletePowerMeter: t`Deleted Power Meter`,
  createPowerMeter: t`Created Power Meter`,
  createPolicy: t`Created Policy`,
  deletePolicy: t`Deleted Policy`,
  createUser: t`Created User`,
  createCustomerFromDeviceToken: t`Created Customer From Device Token`,
  createUserFromDeviceToken: t`Created User From Device Token`,
  createUserFromInvite: t`Created User From Invite`,
  addChangeoverUnit: t`Added Changeover Unit`,
  removeChangeoverUnit: t`Removed Changeover Unit`,
  updateLineBrand: t`Updated Line Brand`,
  addGroupSensor: t`Added Group Sensor`,
  removeGroupSensor: t`Removed Group Sensor`,
  addZoneUnit: t`Added Zone Unit`,
  removeZoneUnit: t`Removed Zone Unit`,
  setConfigParamValue: t`Set Config Param Value`,
  resetLine: t`Reset Line`,
  createSensorGroup: t`Created Sensor Group`,
  updateSensorGroup: t`Updated Sensor Group`,
  deleteSensorGroup: t`Deleted Sensor Group`,
  addSensorToGroup: t`Added Sensor To Group`,
  removeSensorFromGroup: t`Removed Sensor From Group`,
  dissociateServiceUnit: t`Dissociate Service Unit`,
  associateServiceUnit: t`Associate Service Unit`,
  unassignControlUnit: t`Unassign Control Unit`,
  updateBacnetDevice: t`Updated BACnet Device`,
  createBacnetUnit: t`Created BACnet Unit`,
  updateBacnetUnit: t`Updated BACnet Unit`,
  deleteBacnetUnit: t`Deleted BACnet Unit`,
  deleteBacnetDevice: t`Deleted BACnet Device`,
  createBacnetUITemplate: t`Created BACnet UI Template`,
  updateBacnetUITemplate: t`Updated BACnet UI Template`,
  deleteBacnetUITemplate: t`Deleted BACnet UI Template`,
  assignUITemplateToBacnetUnit: t`Assigned UI Template To BACnet Unit`,
  unassignUITemplateFromBacnetUnit: t`Unassigned UI Template From BACnet Unit`,
  createBacnetParamTemplate: t`Created BACnet Param Template`,
  updateBacnetParamTemplate: t`Updated BACnet Param Template`,
  deleteBacnetParamTemplate: t`Deleted BACnet Param Template`,
  assignParamTemplateToBacnetUnit: t`Assigned Param Template To BACnet Unit`,
  unassignParamTemplateFromBacnetUnit: t`Unassigned Param Template From BACnet Unit`,
  createSnoozeRule: t`Created Snooze Rule`,
  deleteSnoozeRule: t`Deleted Snooze Rule`,
  setBacnetUnitObjectValue: t`Set BACnet Unit Object Value`,
  createModbusDevice: t`Created Modbus Device`,
  updateModbusDevice: t`Updated Modbus Device`,
  deleteModbusDevice: t`Deleted Modbus Device`,
  createModbusUnit: t`Created Modbus Unit`,
  updateModbusUnit: t`Updated Modbus Unit`,
  deleteModbusUnit: t`Deleted Modbus Unit`,
  createModbusFunctionalTemplate: t`Created Modbus Functional Template`,
  updateModbusFunctionalTemplate: t`Updated Modbus Functional Template`,
  deleteModbusFunctionalTemplate: t`Deleted Modbus Functional Template`,
  createModbusDeviceTemplate: t`Created Modbus Device Template`,
  updateModbusDeviceTemplate: t`Updated Modbus Device Template`,
  deleteModbusDeviceTemplate: t`Deleted Modbus Device Template`,
  createModbusUITemplate: t`Created Modbus UI Template`,
  updateModbusUITemplate: t`Updated Modbus UI Template`,
  deleteModbusUITemplate: t`Deleted Modbus UI Template`,
  assignUITemplateToModbusUnit: t`Assigned UI Template To Modbus Unit`,
  unassignUITemplateFromModbusUnit: t`Unassigned UI Template From Modbus Unit`,
  createModbusParamTemplate: t`Created Modbus Param Template`,
  updateModbusParamTemplate: t`Updated Modbus Param Template`,
  deleteModbusParamTemplate: t`Deleted Modbus Param Template`,
  assignParamTemplateToModbusUnit: t`Assigned Param Template To Modbus Unit`,
  unassignParamTemplateFromModbusUnit: t`Unassigned Param Template From Modbus Unit`,
  setModbusUnitRegisterValue: t`Set Modbus Unit Register Value`,
  createConditionSearch: t`Created Condition Search`,
  updateConditionSearch: t`Updated Condition Search`,
  deleteConditionSearch: t`Deleted Condition Search`,
  runConditionSearch: t`Run Condition Search`,
  stopConditionSearch: t`Stopped Condition Search`,
  setUnitEWrcEnableOnOff: t`Set Unit EWrc Enable ON/OFF`,
  setUnitEWrcEnableMode: t`Set Unit EWrc Enable Mode`,
  setUnitEWrcEnableSetpoint: t`Set Unit EWrc Enable Setpoint`,
};

export const getActionText = (actionId: string = '', auditActionTitles?: Record<string, string>): string => {

  const action: any = AuditActions[actionId] || auditActionTitles?.[actionId];
  let result = '';
  if (action) {
    result = action;
  } else {
    const actionArray = actionId.split(/(?=[A-Z])/);
    if (["update", "create", "accept", "delete", "remove"].includes(actionArray[0])) {
      actionArray[0] = actionArray[0] + "d";
    }
    if (["add"].includes(actionArray[0])) {
      actionArray[0] = actionArray[0] + "ed";
    }

    actionArray[0] = actionArray[0].charAt(0).toUpperCase() + actionArray[0].substring(1);
    result = actionArray.join(" ").trim();
  }
  return result.replace(/Trap/g, "Trigger").replace(/Event/g, "Alert");
};

export default AuditActions
